// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","492":"component---src-pages-fail-tsx","691":"component---src-pages-index-tsx","855":"component---src-pages-thanks-tsx"}[chunkId] + "-" + {"218":"baf8db6423ea3742a905","492":"f70e7f191ebfb4dc4422","691":"08ec8bef3254a577a63b","855":"ebfe134b41504cd24cd5"}[chunkId] + ".js";
};